import React, { useState, useEffect } from 'react'

// App/AppFonts.css
const FONTS = ['Impact', 'Pixeled', 'Army', 'Typewriter', 'Ethnocentric', 'Groovy','SevenSegment', 'Western', 'OldEnglish', 'Starlight', 'Homework', 'RoadRage'];
/**
 * Renders a font picker dropdown.
 * It allows users to select a font from FONTS which has a class in AppFonts.css.
 * @param {props} props - The properties passed to the FontPicker component.
 * @param {string} props.name - The name of the font picker.
 * @param {string} [props.id=null] - The optional id for the font picker.
 * @param {string} [props.value=null] - The optional default value for the font picker.
 * @returns {JSX.Element} The rendered FontPicker component.
 */
const FontPicker = ({ name, id=null, value=null, onChange=null }) => {
    function handleFontChange(e){
        if (onChange) onChange(e);
    }
    return (
        <div>
            <label htmlFor={name}>{name}</label>
            <select 
                name={name} 
                id={name} 
                defaultValue={value} 
                data-id={id}
                onChange={handleFontChange}
            >
                {FONTS.map((f, i)=>( <option                    
                    key={i} 
                    style={{ fontFamily: f }} 
                    value={f}
                >{f}</option> ))}
            </select>
        </div>
    )
}

export default FontPicker